import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Slider": Slider } } });
export default ClientProvider;
